enum EPaymentService {
  Internal = 'internal',
  Openpay = 'openpay',
}
export default EPaymentService;
